import { createFileRoute } from "@tanstack/react-router";

import EmailChangeTokenPage from "@/features/auth/pages/email-change-verify";

interface TokenSearch {
  // Arrives from the notice to the OLD address: <appBaseUrl>/email-change/revert?token=...
  token?: string;
}

export const Route = createFileRoute("/(auth)/email-change/revert")({
  component: () => (
    <main role="main" aria-label="Undo email change" className="min-h-screen w-full">
      <EmailChangeTokenPage mode="revert" />
    </main>
  ),
  validateSearch: (search: Record<string, unknown>): TokenSearch => ({
    token: search.token as string | undefined,
  }),
});
